import { createSlice } from "@reduxjs/toolkit";

const sliceName = 'filter';
const initialState = {
    searchText: '',
    sort: 'Default'
};

const filterSlice = createSlice({
    name: sliceName,
    initialState,
    reducers: {
        searched: (state, action) => {
            state.searchText = action.payload;
        },
        sorted: (state, action) => {
            state.sort = action.payload;
        }
    }
});

export default filterSlice.reducer;
export const { searched, sorted } = filterSlice.actions;